export function stringToHtml(str = '') {
  return (str || '').replace(/\n/ig, '<br />');
}